import React from "react";
import { connect } from "react-redux";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Tooltip from "@material-ui/core/Tooltip";
import DealExportDialog from "components/Global/Metric/DealExportDialog";
import PrefDialog from "components/Global/Metric/PrefDialog";
import OptionsMenu from "components/Global/OptionsMenu/OptionsMenu";
import { downloadDealQuotes } from "store/state/loan/loan";
import styled from "styled-components";

const StyledTableCell = styled(TableCell)`
  && {
    padding-top: 7px;
  }
`;

const HEADER_OPTIONS = {
  EXPORT_TABLE: 1
  , CHOOSE_COLUMNS: 2
  , DEAL_SUMMARY_EXPORT: 3
}

class EnhancedTableHead extends React.Component {
  static defaultProps = {
    shouldHideExport: false,
    shouldHideConfig: false,
    shouldHideDealExport: true
  }

  state = {
    optionId: null
  };

  options = [
    {
      id: 1,
      value: "Export Table",
      onClick: () => this.setState({ optionId: HEADER_OPTIONS.EXPORT_TABLE })
    },
    {
      id: 2,
      value: "Choose Columns",
      onClick: () => this.setState({ optionId: HEADER_OPTIONS.CHOOSE_COLUMNS })
    },
    {
      id: 3,
      value: "Deal Summary Export",
      onClick: () => this.setState({ optionId: HEADER_OPTIONS.DEAL_SUMMARY_EXPORT })
    }
  ];

  handleMenuSelect = () => {
    const optionId = this.state.optionId;
    if (!optionId) return null;

    switch (optionId) {
      case HEADER_OPTIONS.EXPORT_TABLE:
        this.handleDownloadClick();
        this.setState({ optionId: null });
        break;

      case HEADER_OPTIONS.CHOOSE_COLUMNS:
        return this.renderPrefDialog();

      case HEADER_OPTIONS.DEAL_SUMMARY_EXPORT:
        return this.exportDealDialog();
    }
  }

  createSortHandler = property => event => this.props.onRequestSort(event, property);

  handleDialogClose = () => {
    this.setState({ optionId: null });
    this.props.onClose();
  }

  handleDownloadClick = () => {
    if (this.props.screenType === "fund_table") {
      this.props.downloadFunds();
    } else {
      this.props.exportTable();
    }
  };

  renderPrefDialog() {
    return (
      <PrefDialog
        isMetric={false}
        screenType={this.props.screenType}
        onClose={this.handleDialogClose}
        isOpen={true}
        prefData={this.props.metrics}
        maxCount={6}
      />
    );
  }

  exportDealDialog() {
    return (
      <DealExportDialog
        isMetric={false}
        screenType={this.props.screenType}
        onClose={this.handleDialogClose}
        isOpen={true}
        prefData={this.props.metrics}
        maxCount={6}
      />
    );
  }

  removeOption = (optionId, options) => options.filter(x => x.id !== optionId);

  render() {
    const { order, orderBy, columns, shouldHideConfig, shouldHideExport, shouldHideDealExport } = this.props;

    let filteredOptions = [...this.options];
    if (shouldHideConfig) filteredOptions = this.removeOption(HEADER_OPTIONS.CHOOSE_COLUMNS, filteredOptions);
    if (shouldHideExport) filteredOptions = this.removeOption(HEADER_OPTIONS.EXPORT_TABLE, filteredOptions);
    if (shouldHideDealExport) filteredOptions = this.removeOption(HEADER_OPTIONS.DEAL_SUMMARY_EXPORT, filteredOptions);

    return (
      <React.Fragment>
        {this.handleMenuSelect()}
        <colgroup>
          {columns.map(column => (
            <col key={column.id} width={column.width} />
          ))}
        </colgroup>

        <TableHead>
          <TableRow>
            {columns.map(
              column =>
                column.label || column.blankLabel ? (
                  <TableCell
                    id={`tableHead${(column.label || "").toUpperCase().replace(/\s/g, "")}`}
                    key={column.id}
                    sortDirection={orderBy === column.id ? order : false}
                    className={column.actions && `user_TableActions _4Actions`}
                  >
                    {column.actions || (this.props.sortable !== undefined && !this.props.sortable) ? (
                      <div className="sorting_Label">{column.label}</div>
                    ) : (
                        <Tooltip
                          title={
                            !column.actions ? `Sort by ${column.label}` : `Edit`
                          }
                          placement={
                            column.numeric ? "bottom-end" : "bottom-start"
                          }
                          enterDelay={300}
                        >
                          <TableSortLabel
                            className={`sorting_Label ${
                              orderBy === column.id ? "sortActive" : ""
                              }`}
                            active={orderBy === column.dataField || orderBy === column.id}
                            direction={order}
                            onClick={
                              !column.actions
                                ? this.createSortHandler(column)
                                : this.void()
                            }
                          >
                            {column.label}
                          </TableSortLabel>
                        </Tooltip>
                      )}
                  </TableCell>
                ) : null,
              this
            )}
            {filteredOptions && filteredOptions.length > 0 && (
              <StyledTableCell key="menu">
                <OptionsMenu options={filteredOptions} />
              </StyledTableCell>
            )}
          </TableRow>
        </TableHead>
      </React.Fragment>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(
  mapStateToProps,
  {
    downloadDealQuotes
  }
)(EnhancedTableHead);
